
// Product gallery slider
(function() {
  const slides = document.querySelectorAll('.product-slide');
  /* Seules les vignettes porteuses d'une image sont retenues : les emplacements
     encore vides n'ont pas de data-thumb et ne doivent pas être cliquables. */
  const thumbs = document.querySelectorAll('.product-thumb[data-thumb]');
  const prev = document.getElementById('prodPrev');
  const next = document.getElementById('prodNext');
  let i = 0;
  function go(n) {
    if (!slides.length) return;
    i = (n + slides.length) % slides.length;
    slides.forEach((s, idx) => s.classList.toggle('active', idx === i));
    thumbs.forEach((t) => t.classList.toggle('active', Number(t.dataset.thumb) === i));
  }
  if (prev) prev.addEventListener('click', () => go(i - 1));
  if (next) next.addEventListener('click', () => go(i + 1));
  thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.thumb))));

  /* Rail à aimantation (téléphone). Le défilement est pris en charge par le
     système : on se contente de le suivre pour désigner la vignette active, et
     de l actionner quand on clique une vignette. */
  const cadre = document.querySelector('.product-gallery');
  /* Rail seulement si la galerie défile réellement (« auto » sur téléphone).
     Tester « différent de visible » attrapait aussi l ordinateur, où elle est
     en « hidden » : l image d abonnement, agrandie de 6 %, l y rendait
     défilable de quelques pixels, et l écouteur de défilement ramenait alors
     l image principale après chaque premier clic sur une vignette. */
  const enRail = () => {
    if (!cadre) return false;
    const o = getComputedStyle(cadre).overflowX;
    return o === 'auto' || o === 'scroll';
  };
  if (cadre) {
    const vers = (n) => {
      if (!enRail()) return;
      cadre.scrollTo({ left: n * cadre.clientWidth, behavior: 'smooth' });
    };
    const anc = go;
    go = function (n) { anc(n); vers(i); };
    thumbs.forEach((t) => t.addEventListener('click', () => vers(Number(t.dataset.thumb))));

    let attente = null;
    cadre.addEventListener('scroll', () => {
      if (attente) return;
      attente = requestAnimationFrame(() => {
        attente = null;
        if (!enRail() || !cadre.clientWidth) return;
        const n = Math.round(cadre.scrollLeft / cadre.clientWidth);
        if (n === i) return;
        i = n;
        slides.forEach((s, idx) => s.classList.toggle('active', idx === i));
        thumbs.forEach((t) => t.classList.toggle('active', Number(t.dataset.thumb) === i));
      });
    }, { passive: true });
  }


})();

// Accordion actifs principaux
const activesAcc = document.getElementById('activesAcc');
const activesToggle = activesAcc && activesAcc.querySelector('.actives-toggle');
const activesPanel = activesAcc && activesAcc.querySelector('.actives-content');
if (activesToggle && activesPanel) {
  activesToggle.addEventListener('click', function () {
    const ouvert = activesAcc.classList.toggle('open');
    /* On part toujours de la hauteur réelle du moment, pour qu une bascule en
       cours d animation reparte du bon endroit au lieu de sauter. */
    /* Hauteurs arrondies au pixel entier. Mesurée au centième près, la hauteur
       de départ tombe presque toujours sur une fraction : le navigateur place
       alors le contenu qui suit entre deux pixels et le redistribue à chaque
       image, ce qui se voit comme un tremblement le long du mouvement. */
    const depart = Math.round(activesPanel.getBoundingClientRect().height);
    /* Prévenir le navigateur de ce qui va changer lui permet de préparer la
       couche avant le premier pas, au lieu de la découvrir en route. L avis est
       retiré à l arrivée : laissé en place, il garde de la mémoire pour rien. */
    activesPanel.style.willChange = 'height';
    activesPanel.style.height = depart + 'px';
    void activesPanel.offsetHeight;                 /* fige le point de départ */
    activesPanel.style.height = (ouvert ? Math.round(activesPanel.scrollHeight) : 0) + 'px';
  });
  /* une fois ouvert, la hauteur est libérée : le bloc suit alors son contenu */
  activesPanel.addEventListener('transitionend', function (e) {
    if (e.propertyName !== 'height') return;
    if (activesAcc.classList.contains('open')) activesPanel.style.height = 'auto';
    activesPanel.style.willChange = '';
  });
}

// FAQ accordion
document.querySelectorAll('.faq-item').forEach(item => {
  item.querySelector('.faq-question').addEventListener('click', () => {
    const wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  });
});

// Reveal on scroll
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

// Journey animation: steps reveal + progress bar fill on scroll
(function() {
  const journey = document.querySelector('.journey');
  const fill = document.getElementById('journeyFill');
  const steps = document.querySelectorAll('.journey-step');
  if (!journey || !fill || steps.length === 0) return;

  const stepObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        stepObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3, rootMargin: '0px 0px -50px 0px' });
  steps.forEach(s => stepObserver.observe(s));

  /* L'anneau est animé en CSS : un tour complet en 1,5 s, indépendamment du
     défilement. Le pilotage au scroll ci-dessous ne concerne que l'ancienne
     piste rectiligne, sans quoi il écraserait l'animation et la laisserait
     inachevée — la progression au scroll n'atteignant jamais tout à fait 100%. */
  if (fill.tagName.toLowerCase() === 'circle') return;

  let ticking = false;
  function updateFill() {
    const rect = journey.getBoundingClientRect();
    const vh = window.innerHeight;
    const start = vh * 0.85;
    const end = vh * 0.3;
    const progress = Math.max(0, Math.min(1, (start - rect.top) / (start - end)));
    fill.style.width = (progress * 100) + '%';
    ticking = false;
  }
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateFill);
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  // Laisse peindre l'état à 0% avant de remplir, sinon la transition est sautée
  requestAnimationFrame(() => requestAnimationFrame(updateFill));
})();


/* L ancien quiz a été retiré : le v4 vit dans assets/quiz.js et pilote le
   même #kpQuiz. Les laisser tous deux en place les aurait fait se disputer
   le même élément, chacun réécrivant le contenu de l autre. */



/* ==================== PANIER LATERAL ==================== */
(function () {
  var drawer = document.getElementById('cartDrawer');
  if (!drawer) return;

  var body    = document.getElementById('cartDrawerBody');
  var foot    = document.getElementById('cartDrawerFoot');
  var subtotal= document.getElementById('cartSubtotal');
  var badge   = document.getElementById('cartCount');
  var lastFocus = null;

  /* --- ouverture / fermeture --- */
  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    /* Pas de blocage du défilement : il force un recalcul de toute la page
       au moment où le panneau glisse — d où l à-coup. Le voile suffit. */
    var c = drawer.querySelector('.cart-drawer-close');
    /* focus sans anneau visible ni défilement : il sert au clavier, pas à l œil */
    if (c) c.focus({ preventScroll: true, focusVisible: false });
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); open(); return; }
    var closer = e.target.closest('[data-cart-close]');
    if (closer) {
      /* Un lien porteur de data-cart-close doit pouvoir suivre son adresse : on
         ne bloque l action par défaut que pour ce qui n en a pas. Sans cette
         distinction, le bouton du panier vide fermait le tiroir sans naviguer. */
      var estLien = closer.tagName === 'A' && closer.getAttribute('href');
      if (!estLien) e.preventDefault();
      close();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  /* --- formatage monétaire, d'après la devise renvoyée par le panier --- */
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency || 'EUR'
      }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* --- reconstruction du contenu à partir du panier JSON --- */
  /* Les adresses d'images de l'API panier portent une largeur ; la remplacer
     suffit à obtenir la même image plus définie. */
  function agrandir(url, largeur) {
    if (!url) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + largeur);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + largeur;
  }

  /* Code de bienvenue : appliqué au panier dès qu un abonnement y figure. Il
     n est tenté qu une fois par état du panier — un code refusé ou épuisé ne
     doit pas relancer l appel en boucle. Shopify reporte ensuite le code
     jusqu au paiement ; c est la remise qui le limite à la première livraison. */
  var codeBienvenue = (body.getAttribute('data-code-bienvenue') || '').trim();
  var codeTente = '';
  function verifierCode(cart) {
    if (!codeBienvenue || !cart || !cart.items) return;
    var abo = cart.items.some(function (i) { return i.selling_plan_allocation; });
    var deja = (cart.discount_codes || []).some(function (d) {
      return (d.code || '').toUpperCase() === codeBienvenue.toUpperCase();
    });
    if (!abo || deja) return;
    var etat = cart.token + ':' + cart.item_count + ':' + cart.total_price;
    if (codeTente === etat) return;
    codeTente = etat;
    post('/cart/update.js', { discount: codeBienvenue })
      .then(render)
      .catch(function (err) { console.error(err); });
  }

  /* le prix de la ligne est ce qui est payé maintenant, remises comprises */
  function prixLigne(item, cart) {
    return money(item.final_line_price, cart.currency);
  }

  /* Bandeau sous l en-tête, trois états : panier vide → offre défilante ;
     abonnement dans le panier → « You unlocked free shipping ! » sur fond vert ;
     sinon → simple filet bleu nuit. */
  function majBandeau(cart) {
    var bandeau = document.getElementById('cartBandeau');
    if (!bandeau || !cart) return;
    var items = cart.items || [];
    var abo = items.some(function (i) { return i.selling_plan_allocation; });
    bandeau.classList.toggle('is-abo', abo);
    bandeau.hidden = items.length > 0 && !abo;
  }

  function render(cart) {
    verifierCode(cart);
    majBandeau(cart);
    if (badge) {
      badge.textContent = cart.item_count;
      if (cart.item_count > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    }

    if (!cart.items || cart.items.length === 0) {
      /* On reprend le bloc décrit dans le balisage plutôt que de le réécrire :
         image et bouton restent ainsi définis à un seul endroit. */
      var tpl = document.getElementById('cartEmptyTpl');
      body.innerHTML = tpl ? tpl.innerHTML : '<p class="cart-empty">Your cart is empty.</p>';
      if (foot) foot.setAttribute('hidden', '');
      return;
    }
    if (foot) foot.removeAttribute('hidden');
    if (subtotal) subtotal.textContent = money(cart.items_subtotal_price, cart.currency);

    body.innerHTML = cart.items.map(function (item) {
      /* Les deux faces sont posées ensemble ; c'est la carte qui se retourne,
         aucun visuel n'est remplacé. */
      var subImage = body.getAttribute('data-sub-image');
      var faceAvant = item.image
        ? '<img class="cart-face cart-face--front" src="' + esc(agrandir(item.image, 750)) + '" alt="" loading="lazy">' : '';
      var faceArriere = subImage
        ? '<img class="cart-face cart-face--back" src="' + esc(subImage) + '" alt="" loading="lazy">' : '';
      var img = '<div class="cart-flip' + (item.selling_plan_allocation ? ' is-back' : '') + '" data-flip>' +
                  faceAvant + faceArriere + '</div>';
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<div class="cart-item-variant">' + esc(item.variant_title) + '</div>' : '';
      /* L'API panier ne renvoie que le plan appliqué, jamais ceux qui restent
         disponibles : les caractéristiques de l'abonnement sont donc lues sur le
         conteneur, où Liquid les a déposées au premier rendu. */
      var planId = body.getAttribute('data-plan-id');
      var planPrice = body.getAttribute('data-plan-price') || '';
      var plan;
      var estCarnet = item.handle === 'discipline-kp-notebook';
      if (estCarnet) {
        /* le carnet n a pas d abonnement : l encart renvoie à l offre de
           bienvenue de la crème, où il est offert */
        plan = '<div class="cart-sub-box cart-welcome-box">' +
                 '<p class="cart-welcome-text">Included <strong>for free</strong> in the welcome offer</p>' +
                 '<a class="cart-welcome-btn" href="' + esc(body.getAttribute('data-creme-url') || '/') + '">Welcome offer</a>' +
               '</div>';
      } else if (planId) {
        var coche = item.selling_plan_allocation ? ' checked' : '';
        plan = '<div class="cart-sub-box">' +
                 '<label class="cart-sub-switch">' +
                   '<input type="checkbox" data-sub-toggle' + coche + '>' +
                   '<span class="cart-sub-track" aria-hidden="true"><span class="cart-sub-knob"></span></span>' +
                   '<span class="cart-sub-label">Subscribe &amp; Save : <span class="cart-sub-price">' + esc(planPrice) + '</span></span>' +
                 '</label>' +
                 '<ul class="cart-sub-perks">' +
                   '<li><svg class=\"perk-check\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M4.5 12.8l4.7 4.7L19.5 7.2\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg><span><strong>Free</strong> Discipline tracking pocket notebook</span></li>' +
                   '<li><svg class=\"perk-check\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M4.5 12.8l4.7 4.7L19.5 7.2\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg><span><strong>Free</strong> Shipping</span></li>' +
                   (codeBienvenue ? '<li class="cart-code"><svg class=\"perk-check\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M4.5 12.8l4.7 4.7L19.5 7.2\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg><span class="code-tag"><svg class=\"code-tag-icone\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M3 12.2V4.5A1.5 1.5 0 0 1 4.5 3h7.7l8.8 8.8a1.5 1.5 0 0 1 0 2.1l-7.1 7.1a1.5 1.5 0 0 1-2.1 0z\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\"/><circle cx=\"7.6\" cy=\"7.6\" r=\"1.6\" fill=\"currentColor\"/></svg><span>' + esc(codeBienvenue.toUpperCase()) + '</span></span></li>' : '') +
                 '</ul>' +
               '</div>';
      } else {
        plan = '';
      }
      return '' +
        '<div class="cart-item" data-key="' + esc(item.key) + '">' +
          '<div class="cart-item-media">' + img + '</div>' +
          '<div class="cart-item-info">' +
            (estCarnet
              ? '<div class="cart-item-title cart-item-title--carnet">' + esc(item.product_title).replace('KP Notebook', 'KP<br>Notebook') + '</div>'
              : '<div class="cart-item-title cart-item-title--carnet cart-item-title--tube">' + esc(item.product_title).replace(/(pilaris)\s+/i, '$1<br>') + '</div>') + variant +
            '<div class="cart-item-row">' +
              '<div class="qty">' +
                '<button type="button" class="qty-btn" data-qty="-1" aria-label="Decrease quantity">−</button>' +
                '<span class="qty-value">' + item.quantity + '</span>' +
                '<button type="button" class="qty-btn" data-qty="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="cart-item-price">' + prixLigne(item, cart) + '</span>' +
            '</div>' +
          '</div>' + plan +
          '<button type="button" class="cart-item-remove" data-remove aria-label="Remove">' +
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"></path></svg>' +
          '</button>' +
        '</div>';
    }).join('');
  }

  /* --- appels à l'API panier de Shopify --- */
  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart request failed: ' + r.status);
      return r.json();
    });
  }

  /* « selling_plan » est accepté par le même point d'entrée que la quantité :
     une ligne change de plan sans être retirée puis rajoutée, elle garde donc sa
     place et sa quantité. */
  /* Les changements de plan passent l un après l autre : Shopify renvoie une
     nouvelle clé de ligne à chaque fois, et une bascule faite avant la réponse
     précédente viserait l ancienne clé — elle serait perdue. La clé est donc lue
     au moment de l envoi, et un état intermédiaire déjà dépassé est ignoré. */
  var filePlan = Promise.resolve();
  function changePlan(key, quantity, planId, rang) {
    filePlan = filePlan.then(function () {
      var rowNow = body.querySelectorAll('.cart-item')[rang];
      var bascule = rowNow && rowNow.querySelector('[data-sub-toggle]');
      /* l interrupteur a déjà été rebasculé : seul son dernier état compte */
      var voulu = bascule ? (bascule.checked ? body.getAttribute('data-plan-id') : null) : planId;
      if (voulu !== planId) return;
      var cle = rowNow ? rowNow.getAttribute('data-key') : key;
      return envoiPlan(cle, quantity, planId, rang);
    });
  }
  function envoiPlan(key, quantity, planId, rang) {
    return post('/cart/change.js', { id: key, quantity: quantity, selling_plan: planId })
      .then(function (cart) {
        var ligne = cart.items[rang];
        var row = body.querySelectorAll('.cart-item')[rang];
        if (!ligne || !row) { render(cart); return; }

        /* Shopify reconstruit la clé à partir du plan de vente : sans cette
           mise à jour, les boutons de quantité de la ligne viseraient une clé
           qui n'existe plus. */
        row.setAttribute('data-key', ligne.key);

        var prix = row.querySelector('.cart-item-price');
        if (prix) prix.innerHTML = prixLigne(ligne, cart);
        if (subtotal) subtotal.textContent = money(cart.items_subtotal_price, cart.currency);
        /* passage à l abonnement : le code de bienvenue peut désormais s appliquer */
        verifierCode(cart);
        majBandeau(cart);
      })
      .catch(function (err) { console.error(err); });
  }

  function changeLine(key, quantity) {
    post('/cart/change.js', { id: key, quantity: quantity })
      .then(render)
      .catch(function (err) { console.error(err); });
  }

  /* --- passage à l'abonnement, par délégation --- */
  body.addEventListener('change', function (e) {
    var bascule = e.target.closest('[data-sub-toggle]');
    if (!bascule) return;
    var row = bascule.closest('.cart-item');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var qty = parseInt(row.querySelector('.qty-value').textContent, 10) || 1;
    var planId = body.getAttribute('data-plan-id');
    var rang = [].indexOf.call(body.querySelectorAll('.cart-item'), row);

    /* Le retournement part au clic, sans attendre le serveur : c'est ce qui
       distingue une vraie carte à deux faces d'une image qu'on remplace. */
    var carte = row.querySelector('[data-flip]');
    if (carte) carte.classList.toggle('is-back', bascule.checked);

    /* Le bandeau suit l interrupteur au même instant, sans attendre le
       serveur : les deux mouvements partent ensemble et durent autant. */
    var bandeau = document.getElementById('cartBandeau');
    if (bandeau) {
      var abo = [].some.call(body.querySelectorAll('[data-sub-toggle]'), function (b) { return b.checked; });
      bandeau.classList.toggle('is-abo', abo);
      bandeau.hidden = !abo;
    }

    changePlan(key, qty, bascule.checked ? planId : null, rang);
  });

  /* --- quantité et suppression, par délégation --- */
  body.addEventListener('click', function (e) {
    var row = e.target.closest('.cart-item');
    if (!row) return;
    var key = row.getAttribute('data-key');

    if (e.target.closest('[data-sub-toggle]')) return;   /* traité au « change » */

    if (e.target.closest('[data-remove]')) {
      changeLine(key, 0);
      return;
    }
    var step = e.target.closest('[data-qty]');
    if (step) {
      var current = parseInt(row.querySelector('.qty-value').textContent, 10) || 0;
      var next = current + parseInt(step.getAttribute('data-qty'), 10);
      changeLine(key, next < 0 ? 0 : next);
    }
  });

  /* --- ajout au panier depuis la page produit --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();

    var form = btn.closest('form');
    /* le sélecteur de variante prime sur le champ caché quand il existe */
    var picker = form && form.querySelector('#variant-selector');
    var hidden = form && form.querySelector('input[name="id"]');
    var id = picker ? picker.value : (hidden ? hidden.value : null);
    if (!id) return;

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    /* Le plan vient soit du bouton lui-même, soit de la carte cochée dans le
       sélecteur d'offre. Sans plan, c'est un achat simple. */
    /* quantité : celle du sélecteur s il est présent sur la page */
    var champQte = form && form.querySelector('.qty-input');
    var qte = champQte ? Math.max(1, Math.min(99, parseInt(champQte.value, 10) || 1)) : 1;
    var payload = { id: id, quantity: qte };
    var plan = btn.getAttribute('data-selling-plan');
    if (!plan && form) {
      var choix = form.querySelector('[data-plan-input]:checked');
      if (choix) plan = choix.getAttribute('data-selling-plan');
    }
    if (plan) payload.selling_plan = plan;

    post('/cart/add.js', payload)
      .then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { render(cart); open(); })
      .catch(function (err) { console.error(err); })
      .finally(function () { btn.disabled = false; btn.textContent = label; });
  });
})();

/* ==================== SÉLECTEUR D'OFFRE (page produit) ==================== */
(function () {
  var cartes = document.querySelectorAll('[data-plan-card]');
  if (!cartes.length) return;

  var prixVivant = document.querySelector('[data-live-price]');

  function refleter() {
    var renouv = document.querySelector('[data-renouvellement]');
    var aboChoisi = document.querySelector('[data-plan-input][data-offer="subscription"]:checked');
    if (renouv) renouv.hidden = !aboChoisi;
    cartes.forEach(function (carte) {
      var input = carte.querySelector('[data-plan-input]');
      var actif = !!(input && input.checked);
      carte.classList.toggle('is-selected', actif);
      /* l'état est aussi porté au clavier et aux lecteurs d'écran */
      if (actif && prixVivant) {
        var p = input.getAttribute('data-price');
        if (p) prixVivant.textContent = p;
      }
      if (actif) {
        /* Substitution du visuel de la première position, dans le grand cadre
           comme dans la vignette. On masque au lieu de changer la source : les
           deux images sont déjà chargées, la bascule est donc immédiate et sans
           clignotement. */
        var offre = input.getAttribute('data-offer');
        if (offre) {
          document.querySelectorAll('.offer-img').forEach(function (img) {
            img.hidden = img.getAttribute('data-offer') !== offre;
          });
        }
        /* 5e position : n existe qu avec l abonnement */
        if (offre) {
          var abo = offre === 'subscription';
          var ordi = window.matchMedia('(min-width: 641px)').matches;
          var t3 = document.querySelector('.product-thumb[data-thumb="3"], .product-thumb.carre-abo');
          var t4 = document.querySelector('.product-thumb[data-sub-only]');
          document.querySelectorAll('.product-slide[data-sub-only]').forEach(function (el) {
            if (!abo && el.classList.contains('active')) {
              var t0 = document.querySelector('.product-thumb[data-thumb="0"]');
              if (t0) t0.click();
            }
            el.hidden = !abo;
          });
          if (ordi && t3 && t3.querySelector('.offer-img--recadre') && t4) {
            /* Ordinateur : le carré de l image d abonnement disparaît en entier,
               effacé de haut en bas puis replié ; l image d origine, juste
               dessous, remonte d elle-même à la 4e place. Aucun remplacement. */
            t3.classList.add('carre-abo');
            glisserCarre(t3, !abo);
            t4.hidden = false;
            t4.classList.remove('est-replie');
            /* l image d origine ouvre la 4e diapositive en achat unique (qui la
               montre alors), la 5e avec l abonnement */
            t4.setAttribute('data-thumb', abo ? '4' : '3');
            t3.setAttribute('data-thumb', '3');
          } else {
            document.querySelectorAll('.product-thumb[data-sub-only]').forEach(function (el) { el.hidden = !abo; });
          }
        }
      }
    });
  }

  /* les miniatures qui changent de place glissent de leur ancienne position à la
     nouvelle ; au repli, elles descendent par-dessus le carré d abonnement, qui
     n est retiré de la colonne qu une fois recouvert */
  var glisseJeton = 0;
  function glisserCarre(carre, replier) {
    /* premier affichage : pas d animation */
    if (!carre._init) { carre._init = true; carre.classList.toggle('est-replie', replier); return; }
    var deja = carre.classList.contains('est-replie');
    if (deja === replier && !carre._glisse) return;
    var jeton = ++glisseJeton;
    var autres = Array.prototype.filter.call(carre.parentNode.querySelectorAll('.product-thumb'), function (t) { return t !== carre && !t.hidden; });
    autres.forEach(function (t) { t.style.transition = 'none'; t.style.transform = ''; });
    var avant = autres.map(function (t) { return t.getBoundingClientRect().top; });
    carre.classList.toggle('est-replie', replier);
    var apres = autres.map(function (t) { return t.getBoundingClientRect().top; });
    if (replier) carre.classList.remove('est-replie');
    autres.forEach(function (t, i) { t.style.transform = replier ? '' : 'translateY(' + (avant[i] - apres[i]) + 'px)'; });
    void carre.offsetWidth;
    carre._glisse = true;
    autres.forEach(function (t, i) {
      t.style.transition = 'transform 0.6s cubic-bezier(0.65, 0, 0.35, 1)';
      t.style.transform = replier ? 'translateY(' + (apres[i] - avant[i]) + 'px)' : '';
    });
    setTimeout(function () {
      if (jeton !== glisseJeton) return;
      carre._glisse = false;
      autres.forEach(function (t) { t.style.transition = 'none'; t.style.transform = ''; });
      if (replier) carre.classList.add('est-replie');
      void carre.offsetWidth;
      autres.forEach(function (t) { t.style.transition = ''; });
    }, 620);
  }

  cartes.forEach(function (carte) {
    var input = carte.querySelector('[data-plan-input]');
    if (input) input.addEventListener('change', refleter);
  });

  refleter();
})();

/* ==================== MENU LATÉRAL (téléphone) ==================== */
(function () {
  var drawer = document.getElementById('menuDrawer');
  if (!drawer) return;

  var bouton = document.querySelector('[data-menu-open]');

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    /* Le verrou de défilement n'a de sens que pour le tiroir plein écran du
       bureau. Sur téléphone le menu est une petite carte, et bloquer puis
       relâcher le défilement forçait le navigateur à recalculer la page au
       moment même où elle glissait — d'où le mouvement saccadé. */
    if (!window.matchMedia('(max-width: 640px)').matches) {
      document.body.classList.add('menu-lock');
    }
    if (bouton) bouton.setAttribute('aria-expanded', 'true');
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-lock');
    if (bouton) bouton.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); open(); return; }
    /* Les liens portent eux aussi data-menu-close : le tiroir se referme
       derrière eux, sans quoi il resterait ouvert sur l'ancre atteinte. */
    if (e.target.closest('[data-menu-close]')) { close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();

/* Constellation des actifs, téléphone uniquement.
   Au défilement, le rond dont le centre est le plus proche de la ligne de mire
   (55 % de la hauteur de l écran) est mis en avant ; les autres s assombrissent.
   La mesure se fait dans une trame d animation, le défilement n étant qu un
   simple drapeau, pour ne pas provoquer de recalcul à chaque pixel. */
(function () {
  var ronds = [].slice.call(document.querySelectorAll('.mx-arc-item'));
  if (!ronds.length) return;
  var petit = window.matchMedia('(max-width: 900px)');
  var enAttente = false;

  /* Le voile n est créé qu au premier besoin, et une seule fois. */
  var arc = ronds[0].closest('.mx-arc');
  var voile = null;
  var retrait = null;

  /* Le voile n est dans la page QUE pendant la traversée de la constellation.
     Laissé en permanence, même parfaitement transparent, il recouvrait la
     vidéo de fond sur toute la surface de l écran : les navigateurs mettent en
     pause une vidéo muette lancée d elle-même dès qu ils la jugent masquée, et
     affichent alors le bouton de lecture. On le pose donc à l allumage et on
     le retire une fois le fondu de sortie terminé. */
  function leVoile() {
    if (!voile) {
      voile = document.createElement('div');
      voile.className = 'mx-voile';
      /* dans « .mx » et non sur le corps de page : voir la note du style */
    }
    if (retrait) { clearTimeout(retrait); retrait = null; }
    if (!voile.parentNode) {
      (document.querySelector('.mx') || document.body).appendChild(voile);
      /* une trame d écart, sans quoi l élément naît déjà opaque et le fondu
         d entrée n a pas lieu */
      voile.offsetWidth;
    }
    return voile;
  }

  function rangeVoile() {
    if (!voile || !voile.parentNode) return;
    voile.classList.remove('est-visible');
    if (retrait) clearTimeout(retrait);
    retrait = setTimeout(function () {
      if (voile && voile.parentNode) voile.parentNode.removeChild(voile);
      retrait = null;
    }, 400);
  }

  /* Retour haptique : une brève impulsion au passage d un rond au suivant.
     « navigator.vibrate » n existe que sur Android (Chrome, Firefox, Samsung) ;
     iOS ne l expose pas, la ligne y est donc sans effet et sans erreur. Le
     réglage système « moins d animations » vaut refus. */
  var dernier = null;
  var sobre = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Détour iOS. Depuis la version 17.4, Safari joue un retour haptique système
     quand on actionne un interrupteur — « <input type=checkbox switch> ». Rien
     n oblige l appui à venir du doigt : un « click() » déclenché par le script
     sur l étiquette liée suffit. L interrupteur est donc créé une fois, caché,
     et basculé d avant en arrière à chaque impulsion. C est un effet de bord du
     moteur, pas une interface : il peut disparaître au gré des versions, et
     Safari peut refuser de le jouer hors d un geste direct de l utilisateur.
     Si rien ne se produit, rien ne casse non plus. */
  var bascule = null;
  function detourIOS() {
    if (bascule === false) return null;
    if (bascule) return bascule;
    var essai = document.createElement('input');
    if (!('switch' in essai)) { bascule = false; return null; }
    var etiquette = document.createElement('label');
    etiquette.setAttribute('aria-hidden', 'true');
    etiquette.style.cssText =
      'position:fixed;left:-9999px;top:0;width:1px;height:1px;opacity:0;pointer-events:none';
    essai.type = 'checkbox';
    essai.setAttribute('switch', '');
    essai.tabIndex = -1;
    etiquette.appendChild(essai);
    document.body.appendChild(etiquette);
    bascule = etiquette;
    return bascule;
  }

  function pulse() {
    if (sobre.matches) return;
    if (navigator.vibrate) return navigator.vibrate(10);
    var b = detourIOS();
    if (b) b.click();
  }

  /* ---- la mire : ce qui doit être éclairé, et d où vient la lumière ----
     Les mesures ne sont pas écrites telles quelles dans le style : elles
     alimentent une consigne, que la boucle d animation rejoint peu à peu. Sans
     cela le projecteur sautait d une carte à l autre d une trame sur l autre. */

  var consigne = { glx: 0, gly: 0, gly2: 0 };
  var etat = null;        /* position réellement peinte, en retard sur la consigne */
  var boucle = false;

  /* La source se plaque contre le bord opposé à l élément lu, à sa hauteur.
     Sa nappe est bien plus haute que large : c est ce rapport qui donne la
     colonne de lumière, et non la tache ronde. */
  function poseSource(r) {
    var vw = window.innerWidth;
    var aGauche = (r.left + r.width / 2) < vw / 2;
    consigne.glx = aGauche ? vw : 0;
    consigne.gly = r.top + r.height / 2;
    /* hauteur de la lame : réglée sur celle de la carte, un peu débordante */
    consigne.gly2 = r.height / 2 + 190;
  }


  function peint() {
    /* on écrit sur le voile existant sans jamais le remettre dans la page :
       la boucle de glissement tourne encore quelques trames après l extinction */
    var v = voile;
    if (!v) return;
    v.style.setProperty('--gl-x', etat.glx.toFixed(1) + 'px');
    v.style.setProperty('--gl-y', etat.gly.toFixed(1) + 'px');
    /* très large et courte : la courbure sort de l écran, il ne reste qu une
       lame horizontale entrant par le bord */
    v.style.setProperty('--gl-rx', (window.innerWidth * 2.4) + 'px');
    v.style.setProperty('--gl-ry', etat.gly2.toFixed(1) + 'px');
  }

  /* Rapprochement géométrique : à chaque trame, l état parcourt un dixième du
     chemin qui le sépare de la consigne. Le mouvement démarre franchement et
     se pose sans à-coup, et surtout il ne connaît pas de rupture lorsque la
     consigne change en cours de route — la lumière glisse d une carte à la
     suivante, et traverse l écran quand elle change de bord. */
  function glisse() {
    var k = 0.09;
    var reste = 0;
    for (var cle in consigne) {
      var d = consigne[cle] - etat[cle];
      etat[cle] += d * k;
      reste += Math.abs(d);
    }
    peint();
    if (reste > 1.5) {
      requestAnimationFrame(glisse);
    } else {
      /* arrivé : on cale exactement, et la boucle s arrête */
      for (var c2 in consigne) etat[c2] = consigne[c2];
      peint();
      boucle = false;
    }
  }

  function vers() {
    if (!etat) {                 /* première fois : pas de glissement, on y est */
      etat = {};
      for (var c in consigne) etat[c] = consigne[c];
      peint();
      return;
    }
    if (boucle) return;
    boucle = true;
    requestAnimationFrame(glisse);
  }

  function efface() {
    ronds.forEach(function (r) {
      r.classList.remove('est-vise');
      r.classList.remove('est-efface');
    });
    dernier = null;
    rangeVoile();
    if (arc) arc.classList.remove('est-eclairee');
  }

  function mesure() {
    enAttente = false;
    if (!petit.matches) return efface();

    var mire = window.innerHeight * 0.55;
    /* Portée de la mire. Sans elle, un rond était « visé » dès qu il entrait
       par le bas de l écran : le voile tombait alors que la carte du dessus
       était encore en pleine lecture, et ne se levait qu une fois le dernier
       rond sorti. La page ne s assombrit donc que si un rond se tient dans
       cette bande autour de la ligne de mire. */
    var portee = window.innerHeight * 0.28;
    var vise = null;
    var ecart = portee;

    ronds.forEach(function (r) {
      var b = r.getBoundingClientRect();
      var d = Math.abs(b.top + b.height / 2 - mire);
      if (d < ecart) { ecart = d; vise = r; }
    });

    ronds.forEach(function (r) {
      var cible = r === vise;
      r.classList.toggle('est-vise', cible);
      r.classList.toggle('est-efface', vise !== null && !cible);
    });

    /* L impulsion ne part qu au changement de rond, jamais à chaque trame. */
    if (vise !== dernier) {
      if (vise) pulse();
      dernier = vise;
    }

    if (vise === null) {
      /* Hors de la constellation, la page reste en pleine lumière : l effet
         est réservé aux ingrédients. */
      rangeVoile();
      if (arc) arc.classList.remove('est-eclairee');
      return;
    }

    /* Sur la constellation, pas de clairière : le voile est plein et c est le
       rond visé qui repasse au-dessus de lui. */
    /* Sur la constellation la fenêtre se referme : le voile redevient plein,
       le rond visé passant au-dessus de lui. */
    poseSource(vise.getBoundingClientRect());
    vers();
    leVoile().classList.add('est-visible');
    if (arc) arc.classList.add('est-eclairee');
  }

  function demande() {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(mesure);
  }

  window.addEventListener('scroll', demande, { passive: true });
  window.addEventListener('resize', demande);
  if (petit.addEventListener) petit.addEventListener('change', demande);
  demande();
})();

/* ==================== MENU SHOP DÉROULANT ====================
   Bureau : le panneau se déplie au clic sur Shop ; un clic ailleurs, ou Échap,
   le range. Téléphone : simple dépliant dans le menu. */
(function () {
  var bloc = document.querySelector('[data-shop]');
  if (bloc) {
    var btn = bloc.querySelector('.nav-shop-btn');
    var barre = bloc.closest('.nav');
    var liste = bloc.querySelector('.nav-shop-liste');
    /* bord gauche du bouton Shop, compté depuis celui de la barre ; la carte
       étant en retrait de 16px dans la liste, on les déduit */
    function centre() {
      if (!barre || !liste) return;
      var rb = barre.getBoundingClientRect(), rs = btn.getBoundingClientRect();
      liste.style.setProperty('--shop-gauche', (rs.left - rb.left - 16) + 'px');
    }
    centre();
    window.addEventListener('resize', centre);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(centre);
    function ouvre(v) {
      if (v) centre();
      bloc.classList.toggle('is-open', v);
      btn.setAttribute('aria-expanded', v ? 'true' : 'false');
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      ouvre(!bloc.classList.contains('is-open'));
    });
    /* plus d ouverture au survol : le panneau se déplie au clic sur Shop et se
       range d un clic ailleurs */
    document.addEventListener('click', function (e) {
      if (!bloc.contains(e.target)) ouvre(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') ouvre(false);
    });
  }

  var mob = document.querySelector('[data-shop-mobile]');
  if (mob) {
    var mbtn = mob.querySelector('.menu-shop-btn');
    var mliste = mob.querySelector('.menu-shop-liste');
    /* Déroulé fluide : la hauteur est animée de sa valeur mesurée, en pixels,
       puis libérée (« auto ») une fois ouverte ; au repli, elle repart de sa
       hauteur réelle vers 0. */
    mliste.addEventListener('transitionend', function (e) {
      if (e.target === mliste && e.propertyName === 'height' && mob.classList.contains('is-open')) {
        mliste.style.height = 'auto';
      }
    });
    mbtn.addEventListener('click', function () {
      var v = !mob.classList.contains('is-open');
      var depart = mliste.getBoundingClientRect().height;
      mliste.style.height = depart + 'px';
      void mliste.offsetHeight;
      mob.classList.toggle('is-open', v);
      mbtn.setAttribute('aria-expanded', v ? 'true' : 'false');
      mliste.style.height = v ? mliste.scrollHeight + 'px' : '0px';
    });
  }
})();


/* ==================== SÉLECTEUR DE QUANTITÉ (page produit) ==================== */
(function () {
  document.querySelectorAll('[data-qty-produit]').forEach(function (bloc) {
    var champ = bloc.querySelector('.qty-input');
    function borne(v) { return Math.max(1, Math.min(99, parseInt(v, 10) || 1)); }
    bloc.querySelector('[data-qty-moins]').addEventListener('click', function () { champ.value = borne(champ.value) - 1 || 1; champ.value = borne(champ.value); });
    bloc.querySelector('[data-qty-plus]').addEventListener('click', function () { champ.value = borne(borne(champ.value) + 1); });
    champ.addEventListener('change', function () { champ.value = borne(champ.value); });
  });
})();

/* ==================== OMBRE PORTÉE DE LA CITATION ====================
   Comme si un projecteur éclairait la carte de la citation depuis son coin
   haut-gauche : elle projette une longue ombre bleu nuit vers le sud-est,
   dans la direction exacte du côté bas du triangle des actifs. L ombre part
   des deux coins qui bordent la silhouette (bas-gauche et haut-droit) et file
   jusqu à la ligne du bas de la section, qui la coupe. Ordinateur. */
(function () {
  var bande = document.querySelector('.commit-band');
  var carte = bande && bande.querySelector('.commit-citation-carte');
  var miroir = bande && bande.querySelector('.commit-diag--mirror');
  if (!carte || !miroir) return;
  var NS = 'http://www.w3.org/2000/svg';
  var svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('class', 'commit-ombre');
  svg.setAttribute('aria-hidden', 'true');
  var poly = document.createElementNS(NS, 'path');
  svg.appendChild(poly);
  bande.appendChild(svg);
  /* Contour de l ensemble carte + ombre, au-dessus de la carte : un calque à
     part, la carte passant devant le calque de l ombre. */
  var svg2 = document.createElementNS(NS, 'svg');
  svg2.setAttribute('class', 'commit-ombre commit-ombre-contour');
  svg2.setAttribute('aria-hidden', 'true');
  var contour = document.createElementNS(NS, 'path');
  svg2.appendChild(contour);
  bande.appendChild(svg2);

  /* Repère : le calque lui-même (il exclut la bordure basse de la section ;
     se caler sur la section décalait l ombre de quelques pixels). */
  function pt(x, y) {
    var p = new DOMPoint(x, y).matrixTransform(miroir.getScreenCTM());
    var r = svg.getBoundingClientRect();
    return { x: p.x - r.left, y: p.y - r.top };
  }
  function trace() {
    if (window.innerWidth <= 900 || getComputedStyle(carte).display === 'none') { svg.style.display = 'none'; svg2.style.display = 'none'; return; }
    svg.style.display = '';
    var rb = svg.getBoundingClientRect(), rc = carte.getBoundingClientRect();
    svg.setAttribute('viewBox', '0 0 ' + rb.width + ' ' + rb.height);
    svg.setAttribute('preserveAspectRatio', 'none');
    /* direction du côté bas du triangle des actifs, de la pointe vers le bas */
    var a = pt(692.8, 425.7), b = pt(0, 678);
    var dx = b.x - a.x, dy = b.y - a.y, n = Math.hypot(dx, dy); dx /= n; dy /= n;
    var L = rb.width * 2;
    /* Les bords de l ombre sont tangents aux coins arrondis : on part du point
       de chaque arrondi où la direction de la lumière effleure le cercle. */
    var R = parseFloat(getComputedStyle(carte).borderTopLeftRadius) || 0;
    var nx = dy, ny = -dx;                                       /* normale vers le haut-droit */
    var cbg = { x: rc.left - rb.left + R, y: rc.bottom - rb.top - R };
    var chd = { x: rc.right - rb.left - R, y: rc.top - rb.top + R };
    var bg = { x: cbg.x - nx * R, y: cbg.y - ny * R };          /* tangence, coin bas-gauche */
    var hd = { x: chd.x + nx * R, y: chd.y + ny * R };          /* tangence, coin haut-droit */
    /* contour : bord bas de l ombre, puis le pourtour de la carte (arrondis
       compris) jusqu au point de tangence haut-droit, puis bord haut de l ombre */
    var l = rc.left - rb.left, t = rc.top - rb.top, r = rc.right - rb.left, b = rc.bottom - rb.top;
    svg2.setAttribute('viewBox', '0 0 ' + rb.width + ' ' + rb.height);
    svg2.setAttribute('preserveAspectRatio', 'none');
    svg2.style.display = '';
    contour.setAttribute('d',
      'M ' + (bg.x + dx * L) + ' ' + (bg.y + dy * L) + ' L ' + bg.x + ' ' + bg.y +
      ' A ' + R + ' ' + R + ' 0 0 1 ' + l + ' ' + (b - R) +
      ' L ' + l + ' ' + (t + R) +
      ' A ' + R + ' ' + R + ' 0 0 1 ' + (l + R) + ' ' + t +
      ' L ' + (r - R) + ' ' + t +
      ' A ' + R + ' ' + R + ' 0 0 1 ' + hd.x + ' ' + hd.y +
      ' L ' + (hd.x + dx * L) + ' ' + (hd.y + dy * L));
    poly.setAttribute('d', 'M ' + bg.x + ' ' + bg.y + ' L ' + hd.x + ' ' + hd.y +
      ' L ' + (hd.x + dx * L) + ' ' + (hd.y + dy * L) + ' L ' + (bg.x + dx * L) + ' ' + (bg.y + dy * L) + ' Z');
  }
  trace();
  window.addEventListener('resize', trace);
  window.addEventListener('load', trace);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(trace);
})();

/* ==================== CITATION, TÉLÉPHONE : OMBRE ET CONTOUR ====================
   Même principe que sur ordinateur : ombre vers le sud-est à 20°, partant des
   points de tangence des coins arrondis, coupée par le bas du bloc ; contour de
   l ensemble carte + ombre. */
(function () {
  var bloc = document.querySelector('.commit-citation-mobile');
  var carte = bloc && bloc.querySelector('.commit-citation');
  if (!carte) return;
  var NS = 'http://www.w3.org/2000/svg';
  function calque(cls) {
    var s = document.createElementNS(NS, 'svg'); s.setAttribute('class', 'cmo-calque ' + cls);
    s.setAttribute('aria-hidden', 'true'); s.setAttribute('preserveAspectRatio', 'none');
    var p = document.createElementNS(NS, 'path'); s.appendChild(p); bloc.appendChild(s); return [s, p];
  }
  var o = calque('cmo-ombre'), c = calque('cmo-contour');
  function trace() {
    if (getComputedStyle(bloc).display === 'none') return;
    /* échelle : la réplique de 460,8px est ajustée à la largeur de l écran */
    var k = (bloc.getBoundingClientRect().width - 24) / 460.8;
    carte.style.setProperty('--cmo-echelle', k.toFixed(4));
    var rb = o[0].getBoundingClientRect(), rc = carte.getBoundingClientRect();
    [o[0], c[0]].forEach(function (s) { s.setAttribute('viewBox', '0 0 ' + rb.width + ' ' + rb.height); });
    var a = 20 * Math.PI / 180, dx = Math.cos(a), dy = Math.sin(a), L = rb.width * 3;
    var R = (parseFloat(getComputedStyle(carte).borderTopLeftRadius) || 0) * k, nx = dy, ny = -dx;
    var l = rc.left - rb.left, t = rc.top - rb.top, r = rc.right - rb.left, b = rc.bottom - rb.top;
    var bg = { x: l + R - nx * R, y: b - R - ny * R }, hd = { x: r - R + nx * R, y: t + R + ny * R };
    o[1].setAttribute('d', 'M ' + bg.x + ' ' + bg.y + ' L ' + hd.x + ' ' + hd.y + ' L ' + (hd.x + dx * L) + ' ' + (hd.y + dy * L) +
      ' L ' + (bg.x + dx * L) + ' ' + (bg.y + dy * L) + ' Z');
    c[1].setAttribute('d', 'M ' + (bg.x + dx * L) + ' ' + (bg.y + dy * L) + ' L ' + bg.x + ' ' + bg.y +
      ' A ' + R + ' ' + R + ' 0 0 1 ' + l + ' ' + (b - R) + ' L ' + l + ' ' + (t + R) +
      ' A ' + R + ' ' + R + ' 0 0 1 ' + (l + R) + ' ' + t + ' L ' + (r - R) + ' ' + t +
      ' A ' + R + ' ' + R + ' 0 0 1 ' + hd.x + ' ' + hd.y + ' L ' + (hd.x + dx * L) + ' ' + (hd.y + dy * L));
  }
  trace();
  window.addEventListener('resize', trace);
  window.addEventListener('load', trace);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(trace);
})();

/* ==================== IMAGES DÉFILANTES, TÉLÉPHONE ====================
   Le défilement automatique est repris par le script : la piste avance d elle-
   même, le doigt peut la saisir et la lancer plus vite, et elle revient en
   douceur à sa vitesse de croisière (élan amorti, sans rupture). Un appui bref
   sur une image l agrandit ; un nouvel appui la referme. */
(function () {
  var cadre = document.querySelector('.marquee');
  var piste = cadre && cadre.querySelector('.marquee-track');
  if (!piste) return;
  var tel = window.matchMedia('(max-width: 640px)');
  var actif = false, x = 0, v = 0, moitie = 0, dernier = 0, croisiere = 0;
  var touche = null;

  function mesurer() { moitie = piste.scrollWidth / 2; croisiere = moitie / 50; }   /* même vitesse que l animation d origine */
  function boucle(t) {
    if (!actif) return;
    var dt = dernier ? Math.min(0.05, (t - dernier) / 1000) : 0; dernier = t;
    if (!touche) {
      /* l élan rejoint la vitesse de croisière en douceur (~0,8 s) */
      v += (croisiere - v) * (1 - Math.exp(-dt * 2.6));
      x += v * dt;
    }
    if (moitie) { x = ((x % moitie) + moitie) % moitie; }
    piste.style.transform = 'translate3d(' + (x - moitie) + 'px,0,0)';
    requestAnimationFrame(boucle);
  }
  function demarrer() {
    if (actif) return;
    mesurer(); if (!moitie) return;
    /* on part de la position où l animation CSS se trouvait : pas de saut */
    var m = new DOMMatrix(getComputedStyle(piste).transform);
    x = m.m41 + moitie; v = croisiere;
    piste.style.animation = 'none';
    actif = true; dernier = 0; requestAnimationFrame(boucle);
  }
  function arreter() { actif = false; piste.style.animation = ''; piste.style.transform = ''; }
  function selon() { if (tel.matches) demarrer(); else arreter(); }

  cadre.addEventListener('touchstart', function (e) {
    if (!actif) return;
    var p = e.touches[0];
    touche = { x0: p.clientX, y0: p.clientY, x: p.clientX, t: performance.now(), t0: performance.now(), vit: 0, horiz: null };
  }, { passive: true });
  cadre.addEventListener('touchmove', function (e) {
    if (!touche) return;
    var p = e.touches[0], dx = p.clientX - touche.x;
    if (touche.horiz === null) {
      var ax = Math.abs(p.clientX - touche.x0), ay = Math.abs(p.clientY - touche.y0);
      if (ax + ay > 6) touche.horiz = ax > ay;
    }
    if (touche.horiz === false) { touche = null; return; }   /* défilement vertical de la page : on laisse faire */
    if (touche.horiz) e.preventDefault();
    var t = performance.now(), dt = Math.max(1, t - touche.t) / 1000;
    x += dx; touche.vit = touche.vit * 0.5 + (dx / dt) * 0.5;
    touche.x = p.clientX; touche.t = t;
  }, { passive: false });
  cadre.addEventListener('touchend', function (e) {
    if (!touche) return;
    var bref = performance.now() - touche.t0 < 300 && Math.abs(touche.x - touche.x0) < 8;
    if (touche.horiz) v = Math.max(-4000, Math.min(4000, touche.vit));   /* lancer */
    var cible = bref ? e.target.closest('.marquee-item') : null;
    touche = null;
    if (cible) agrandir(cible);
  });

  /* ---- agrandissement ----
     L image est réellement « prise » : l original est masqué dans la bande,
     qui continue de défiler. À la fermeture, la copie rejoint l emplacement de
     l original là où il se trouve à cet instant, puis l original réapparaît. */
  var voile = null;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  function poser(el, r) {
    el.style.left = r.left + 'px'; el.style.top = r.top + 'px';
    el.style.width = r.width + 'px'; el.style.height = r.height + 'px';
  }
  function agrandir(item) {
    if (voile) return;
    var r = item.getBoundingClientRect();
    voile = document.createElement('div');
    voile.className = 'marquee-zoom';
    var copie = item.cloneNode(true);
    copie.className = 'marquee-item marquee-zoom-item';
    copie.removeAttribute('aria-hidden');
    poser(copie, r);
    voile.appendChild(copie); document.body.appendChild(voile);
    item.style.visibility = 'hidden';
    var L = Math.min(window.innerWidth * 0.86, 420), H = L * r.height / r.width;
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      voile.classList.add('is-on');
      poser(copie, { left: (window.innerWidth - L) / 2, top: (window.innerHeight - H) / 2, width: L, height: H });
    }); });
    voile.addEventListener('click', function fermer() {
      voile.removeEventListener('click', fermer);
      voile.classList.remove('is-on');
      /* La bande continue de défiler : la copie vise la position VIVANTE de
         son emplacement, relue à chaque image, et l y rejoint en 0,45 s. */
      var b0 = copie.getBoundingClientRect(), t0 = performance.now(), D = 450, v2 = voile;
      copie.style.transition = 'none';
      function ease(t) { return 1 - Math.pow(1 - t, 3); }
      (function suivre(t) {
        var k = Math.min(1, (t - t0) / D), e = ease(k), c = item.getBoundingClientRect();
        poser(copie, { left: b0.left + (c.left - b0.left) * e, top: b0.top + (c.top - b0.top) * e,
                       width: b0.width + (c.width - b0.width) * e, height: b0.height + (c.height - b0.height) * e });
        if (k < 1) requestAnimationFrame(suivre);
        else { item.style.visibility = ''; v2.remove(); if (voile === v2) voile = null; }
      })(t0);
    });
  }

  window.addEventListener('resize', function () { if (actif) mesurer(); });
  if (tel.addEventListener) tel.addEventListener('change', selon);
  window.addEventListener('load', selon);
  selon();
})();

/* Languette du quiz : même forme sur tous les écrans ; sur téléphone, sa
   taille suit en plus la vitesse de la page.
   Elle reste réduite tant que la page file, et regrossit d un mouvement
   normal dès que la page ralentit, juste avant son arrêt. Sa forme (trapèze à
   flancs de 45°, angles arrondis) est dessinée une fois ; la taille ne change
   que par une mise à l échelle (--kp-s), fluide. */
(function () {
  var languette = document.getElementById('kpReopen');
  if (!languette) return;
  var tel = window.matchMedia('(max-width: 640px)');
  var DEBORD = 4; /* px hors de l écran, cf. quiz-v4.css */
  var r = 0, vit = 0, dernierY = 0, dernierT = 0, tourne = false;
  var petite = false, departT = 0, departR = 0;

  function dessiner() {
    var W = languette.offsetWidth, H = languette.offsetHeight;
    var w = W - DEBORD;             /* largeur visible = hauteur d un flanc */
    var k = 7;                      /* arrondi intérieur, contre l écran */
    var ro = 14;                    /* arrondi extérieur */
    var ext = k + w, T = H + 2 * ext, q = Math.SQRT1_2;
    /* coordonnées « écran » : x = 0 au bord de l écran, vers la droite */
    var Ay = k, By = k + w, Cy = By + H, Dy = Cy + w;
    var pts = [
      ['M', -DEBORD, 0], ['L', 0, 0],
      ['Q', 0, Ay, k * q, Ay + k * q],
      ['L', w - ro * q, By - ro * q],
      ['Q', w, By, w, By + ro],
      ['L', w, Cy - ro],
      ['Q', w, Cy, w - ro * q, Cy + ro * q],
      ['L', k * q, Dy - k * q],
      ['Q', 0, Dy, 0, Dy + k],
      ['L', -DEBORD, T]
    ];
    /* la languette est retournée d un demi-tour : on dessine en miroir */
    var d = pts.map(function (p) {
      var out = p[0];
      for (var i = 1; i < p.length; i += 2) {
        out += ' ' + (W - (p[i] + DEBORD)).toFixed(2) + ' ' + (T - p[i + 1]).toFixed(2);
      }
      return out;
    }).join(' ') + ' Z';
    languette.style.setProperty('--kp-ext', ext.toFixed(2) + 'px');
    languette.style.setProperty('--kp-forme', "path('" + d + "')");
    languette.classList.add('kp-forme-ok');
  }

  function image(t) {
    var dt = Math.max(1, t - dernierT);
    var v = Math.abs(window.scrollY - dernierY) / dt; /* px par ms */
    dernierY = window.scrollY; dernierT = t;
    vit += (v - vit) * 0.3;
    /* réduite tant que la page file ; sous 0,3 px/ms — la page ralentit, pas
       encore arrêtée — elle regrossit d un seul mouvement de 0,35 s, sans
       suivre la vitesse. Elle ne se réduit de nouveau qu au-dessus de 0,5. */
    if (petite && vit < 0.3) { petite = false; departT = t; departR = r; }
    else if (!petite && vit > 0.5) petite = true;
    if (petite) {
      r += (1 - r) * 0.35;
    } else {
      var p = Math.min(1, (t - departT) / 350);
      r = departR * (1 - (1 - Math.pow(1 - p, 3)));
    }
    if (!petite && r === 0 && vit < 0.02) {
      tourne = false;
      languette.style.removeProperty('--kp-s');
      return;
    }
    languette.style.setProperty('--kp-s', (1 - 0.28 * r).toFixed(4));
    requestAnimationFrame(image);
  }
  window.addEventListener('scroll', function () {
    if (tourne || !tel.matches) return;
    tourne = true;
    dernierT = performance.now();
    requestAnimationFrame(image);
  }, { passive: true });
  /* position figée en pixels : recalculée seulement quand la largeur change
     (rotation), jamais quand la barre du navigateur se replie */
  var largeur = 0;
  function placer() {
    if (window.innerWidth === largeur) return;
    largeur = window.innerWidth;
    languette.style.setProperty('--kp-top', Math.round(window.innerHeight * 0.78) + 'px');
  }
  placer();
  window.addEventListener('resize', function () { placer(); dessiner(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(dessiner);
  dernierY = window.scrollY;
  dessiner();
})();
